module.exports = __webpack_public_path__ + "static/media/hero-bg-desktop.3cbdc75d.png";